export class Column {

    public display: string;
    public variable: string;

    constructor(display: string, variable: string) {
        this.display = display;
        this.variable = variable;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/column.ts